import React from "react";
import "./Discount.css";

const Discount = () => {
  return (
    <div className="p-10 bg" style={{ color: "#333333" }}>
      <h1 className="text-5xl font-bold text-center">
        10% Discount of all services!
      </h1>
    </div>
  );
};

export default Discount;
